/*
 * Copyright © 2015-2017 Serenova, LLC. All rights reserved.
 */

/**
 *
 * ErrorBoundary
 * A higher order component to wrap other components in to handle render and selector errors.
 * https://reactjs.org/blog/2017/07/26/error-handling-in-react-16.html
 *
 */

import React from 'react';
import styled from 'styled-components';
import { Redirect } from 'react-router-dom';
import store from '../../redux/store';

const FallBackUi = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: blue;
    font-weight: bold;
    height:300px;
`;

export default class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { error: null, redirect: false };
    }

    componentDidCatch(error, info) {
      console.error(error, info);
      this.setState({ error });
      store.dispatch({type: 'RESET_APP'});
      window.localStorage.clear();
    }

    render() {
        if (this.state.redirect) {
        <Redirect to="/" />;
        window.location.reload();
      }
      if (this.state.error) {
        return <FallBackUi>
                <h3>Something went wrong. Please click here to <span
            style={{ cursor: 'pointer', color: '#0077FF' }}
            onClick={() => this.setState({redirect: true})}
          >login again</span></h3>
        </FallBackUi>;
      }
      
      return this.props.children;   
    }
  }